import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

// iOS WebKit wedges React-reconciled video players (loader stalls at t=0, full buffer, no error)
// while an identical imperatively-created element plays — same fix as the thread/preview players.
const IS_IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

// Plays a video in a modal. Reused for previewing a composer attachment before sending and (later)
// for viewing a sent thread video. Source-agnostic — pass a local blob URL or a signed Cloudinary URL.
function VideoPreviewModal({
 show, onHide, src, title = 'Video', modalClassName = null,
}) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" className={modalClassName}>
      <Modal.Header closeButton className="border-0">
        <Modal.Title style={{ fontSize: '18px' }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {src && (
          IS_IOS ? (
            <div
              ref={(host) => {
                if (!host || host.dataset.mounted) return;
                // eslint-disable-next-line no-param-reassign -- marking the host node is the point
                host.dataset.mounted = '1';
                const el = document.createElement('video');
                el.src = src;
                el.controls = true;
                el.setAttribute('playsinline', '');
                el.className = 'w-100 rounded';
                el.style.cssText = 'background:#000;max-height:70vh;display:block;';
                host.appendChild(el);
              }}
            />
          ) : (
            <video
              src={src}
              controls
              autoPlay
              playsInline
              className="w-100 rounded"
              style={{ background: '#000', maxHeight: '70vh', display: 'block' }}
            >
              <track kind="captions" />
            </video>
          )
        )}
      </Modal.Body>
    </Modal>
  );
}

VideoPreviewModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  src: PropTypes.string,
  title: PropTypes.string,
  modalClassName: PropTypes.string,
};

export default VideoPreviewModal;
